import { createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteVouchersParams } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const deleteVouchers = createAsyncThunk<void, DeleteVouchersParams>(
  "vouchers/deleteVouchers",
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      await VouchersAPI.deleteVouchers({
        voucherId,
        ...params,
      });
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while deleting voucher", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error("Error while deleting voucher", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
